import React from "react";
import { Box, Typography } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";

/**
 * Ubicación del artículo en el almacén (campo UBICACION del maestro de artículos).
 * Sale de la misma consulta que el stock (useStocks), así que mientras carga
 * (`undefined`) o si la consulta falló (`null`) no pinta nada; una cadena vacía es
 * un artículo sin ubicación asignada.
 * @param {string|null|undefined} ubicacion - Ubicación del artículo
 */
const UbicacionArticulo = ({ ubicacion }) => {
    if (ubicacion == null) return null;

    const sinUbicacion = ubicacion === "";

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <PlaceIcon sx={{ fontSize: 15, color: sinUbicacion ? "#adb5bd" : "#cc071e" }} />
            <Typography sx={{ fontSize: 12.5, fontWeight: sinUbicacion ? 400 : 600, color: sinUbicacion ? "#6c757d" : "#212529" }}>
                {sinUbicacion ? "Sin ubicación" : ubicacion}
            </Typography>
        </Box>
    );
};

export default UbicacionArticulo;
